import { StyleSheet, View, ViewProps, useWindowDimensions } from 'react-native'
import { Spacing } from 'zens-storybook'
import { useTranslation } from 'react-i18next'
import { Suspense, useRef } from 'react'
import {
  useNumberParams,
  useParams,
  usePeriodParam,
  useSortParam,
  useWeekdaysParam,
  useWorkingHoursParam,
} from 'zens-router'

import { InsightsHeatmap, InsightsHeader, LayoutHeader, InsightsHead, InsightsHeatmapRef } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  head: {
    zIndex: 100,
  },
  hack: {
    width: 2,
    height: 2,
  },
})

interface Props extends ViewProps {}

const InsightsHeatmapScreen = (props: Props) => {
  const { style, ...otherProps } = props
  const { t } = useTranslation()
  const [{ companyId, buildingId, floorId }] = useNumberParams()
  const [weekdays] = useWeekdaysParam()
  const [workingHours] = useWorkingHoursParam()
  const [params, setParams] = useParams()
  const { selected } = params
  const [period] = usePeriodParam()
  const [sort, setSort] = useSortParam()
  const { height } = useWindowDimensions()
  const contentStyle = { minHeight: height }
  const insights = useRef<InsightsHeatmapRef>(null)

  return (
    <View style={[styles.container, contentStyle, style]} {...otherProps}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <InsightsHeader
          companyId={companyId}
          buildingId={buildingId}
          title={t('Historical heatmap')}
          breadcrumbItems={[{ title: t('Historical heatmap') }]}
        />
      </Suspense>
      <View style={styles.content}>
        <InsightsHead
          companyId={companyId}
          buildingId={buildingId}
          style={styles.head}
          floorExtraItems={[]}
          downloadItems={[
            {
              key: 'data',
              icon: 'download',
              title: t('Download data'),
              testID: 'InsightsHeatmap.DownloadData',
            },
            {
              key: 'heatmap',
              icon: 'download',
              title: t('Download heatmap'),
              testID: 'InsightsHeatmap.DownloadHeatmap',
            },
          ]}
          onDownload={(key) => insights.current?.download(key)}
          href={(buildingId, floorId) => `/companies/${companyId}/insights/${buildingId}/floors/${floorId}`}
        />
        <Suspense fallback={<InsightsHeatmap.Skeleton />}>
          <InsightsHeatmap
            ref={insights}
            companyId={companyId}
            buildingId={buildingId}
            floorId={floorId}
            period={period}
            weekdays={weekdays}
            workingHours={workingHours}
            selected={selected !== 'undefined' ? selected : undefined}
            onSelect={(selected) => setParams(selected ? { selected } : {})}
            sort={sort}
            onSortChange={setSort}
          />
        </Suspense>
      </View>
      {/* This is a hack to prevent flickering scrollbars on Windows Edge browser */}
      <View style={styles.hack} />
    </View>
  )
}

export default InsightsHeatmapScreen
